module.exports = __webpack_public_path__ + "static/media/fa-v4compatibility.72b4a1c3.ttf";